// exp_PORTFOLIO-58018_file
import { FC } from 'react';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import vrPackageFormElementShown from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vr_package/vr_package_form_element_shown';
import { GridColumn, GridLayout, GridRow, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';

import { StickyActionBarWrapper } from 'components/common/StickyActionBarWrapper/StickyActionBarWrapper';
import { Areas } from 'components/VrCampaignBuilder/components/Areas';
import { CustomResponsesAndBudget } from 'components/VrCampaignBuilder/components/CustomResponsesAndBudget/CustomResponsesAndBudget';
import { MobileScreensTip } from 'components/VrCampaignBuilder/components/MobileScreensTip';
import { OneReponsePriceBanner } from 'components/VrCampaignBuilder/components/OneReponsePriceBanner';
import { Presets } from 'components/VrCampaignBuilder/components/Presets';
import { Requirements } from 'components/VrCampaignBuilder/components/Requirements';
import { Sidebar } from 'components/VrCampaignBuilder/components/Sidebar';
import { VrCampaignActions } from 'components/VrCampaignBuilder/components/VrCampaignActions';
import { VrRequestModal } from 'components/VrCampaignBuilder/components/VrRequestModal/VrRequestModal';

import { selectVrCampaignVacancyId } from 'store/models/vrCampaign';
import { useSelector } from 'store/utils';

export const VrCampaignBuilder: FC = () => {
    const vacancyId = useSelector(selectVrCampaignVacancyId);

    return (
        <StickyActionBarWrapper
            content={
                <ElementShownAnchor fn={vrPackageFormElementShown} vacancyId={vacancyId ?? 0}>
                    <GridLayout>
                        <GridRow>
                            <GridColumn xs={4} s={8} l={6}>
                                <VSpacingContainer default={32}>
                                    <div>
                                        <MobileScreensTip />
                                        <Presets />
                                        <CustomResponsesAndBudget />
                                        <OneReponsePriceBanner />
                                    </div>
                                    <Requirements />
                                    <Areas />
                                </VSpacingContainer>
                                <VSpacing default={32} />
                            </GridColumn>
                            <GridColumn xs={0} l={2} />
                            <GridColumn xs={0} m={4}>
                                <Sidebar />
                            </GridColumn>
                        </GridRow>
                    </GridLayout>

                    <VrRequestModal />
                </ElementShownAnchor>
            }
            actionBar={<VrCampaignActions />}
        />
    );
};
